import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import Sticky from 'Components/Sticky';
import { PROVIDER, SEEKER, USER_TYPE, CARGILL, PANTALOONS, CENTURY_PLY, DESMET, ARDEX_MIS_REPORT, GREENPLY_IDs, MITSUI, RAJ_PETRO, SAP_DEEPAK_PHENOLICS } from 'Constants/commonConstants';
import {
    GET_GOOGLE_STUDIO_REPORT,
    GET_HOLISTICS,
    SAVE_USER_REPORT_UTILIZATION_EVENT
} from 'Constants/actionConstants';
import { getCompanyType, getUserType, getUser } from 'Utils/storage';
import classnames from 'classnames';
import ActionLoader from 'Components/ActionLoader';
import { getEmbedCode } from 'Utils/common';

const dashboards = {};
const user = getUser();
const companyTextId = user.company_text_id;
const companyId = user.company_id;

if (SEEKER) {
    dashboards[SEEKER] = {
        'default': {}
    };
    let matchFound = false;

    if(['LOREAL'].includes(companyTextId)){
        dashboards[SEEKER]['default']['1'] = [`L'OREAL - LR TRACKING DASHBOARD`, '7eba992ebb8442c4b78cf4a5a8f9705b'],
        matchFound = true; 
    }

    if (companyId==='0') {
        //************ SUPER ADMIN BLOCK********************/
        // dashboards[SEEKER]['default']['1'] = [`Tracking MIS (SA)`, '916b9bf926277300114b7d37'];
        // dashboards[SEEKER]['default']['2'] = ['Transporter Performance Report', 'c062b06b483b3c370597fd09'];
        // dashboards[SEEKER]['default']['3'] = ['Key Metrics Report', 'b5ea5d5f0d6405f2d9dbdbfa'];
        // dashboards[SEEKER]['default']['4'] = ['Key Information Dashboard', 'a03b5713939f01736226f708'];
        // dashboards[SEEKER]['default']['5'] = ['Completed Trips', '6f613481542f656f994a309a'];
        matchFound = true;
    }

    //**********************/ DEFAULT SEEKER  COMPANY SCENARIO /******************************** */
    if (!matchFound) {
        // dashboards[SEEKER]['default']['1'] = [`Tracking MIS`, getEmbedCode(companyTextId)];
        // dashboards[SEEKER]['default']['2'] = ['Transporter Performance Report', 'c062b06b483b3c370597fd09'];
        // dashboards[SEEKER]['default']['3'] = ['Key Metrics Report', 'b5ea5d5f0d6405f2d9dbdbfa'];
        // dashboards[SEEKER]['default']['4'] = ['Key Information Dashboard', 'a03b5713939f01736226f708'];
        // dashboards[SEEKER]['default']['5'] = ['Completed Trips', '6f613481542f656f994a309a'];
    }
    //**************************************************************************************** */


    // dashboards[SEEKER][USER_TYPE.ZONE] = {
    //     '1': ['Tracking MIS', '8a61f91bb451fd67e161619e'],
    //     '5': ['Completed Trips', 'a069e7d2b544679aaf90eec5']
    // };
}

const companyType =  getCompanyType();
const userType = getUserType();

class HolisticsDashboards extends Component {
    constructor() {
        super();
        this.state = {
            isLoading:true,
            activeTab : '1',
            report_id :  (dashboards[companyType][userType] || dashboards[companyType]['default'])['1'][1],
        }
    }


    toggle = (activeTab, report_id , dashboardName) => {
        this.setState({ activeTab, report_id },() => {
            this.getDashboard();
        });
        this.handleOnClickForReport(dashboardName)
    }

    getDashboard = () => {
        const { dispatch } = this.props;

        dispatch({
            type: GET_GOOGLE_STUDIO_REPORT,
            params: {
                report_id: this.state.report_id
            }
        })
    }


    componentWillReceiveProps(nextProps){
        // if(nextProps.token !== this.state.token) {
        //     this.setState({ token : nextProps.token });
        // }
    }


    handleOnClickForReport = (report_name) => {
        const { dispatch } = this.props;
        dispatch({
            type: SAVE_USER_REPORT_UTILIZATION_EVENT,
            payload: {
                event_name: "on_click_of_report",
                report_name: report_name
            },
        });
    }

    render() {
        const { data } = this.props;
        const activeTab = this.state.activeTab;
        const availableDashboards = dashboards[companyType][userType] || dashboards[companyType]['default'];
        console.log('availableDashboards:', availableDashboards)
        return (
            <Sticky activeLink={'holistic-dashboards'}>
                {this.state.isLoading && <ActionLoader fixed={true}></ActionLoader>}
                <Nav tabs className={'flex'} style={{'border': '1px solid lightgrey'}}>
                    {
                        Object.keys(availableDashboards).map((key, index) => {
                            const dashboardName = availableDashboards[key][0];
                            const report_id = availableDashboards[key][1];
                            return (
                                <NavItem style={{'borderRight': '1px solid lightgrey', 'textAlign': 'center'}}>
                                    <NavLink
                                        className={classnames('fBolder', { active: activeTab === key })}
                                        onClick={() => {
                                            this.toggle(key, report_id, dashboardName)
                                        }}
                                    >
                                    {dashboardName}
                                    </NavLink>
                                </NavItem>
                            )
                        })
                    }
                </Nav>
                <TabContent activeTab={activeTab}>
                    {
                        data.report_id  && Object.keys(availableDashboards).map((key, index) => {
                            return (
                                <TabPane tabId={key}>
                                    <iframe
                                        src={data.src}
                                        style={{width: "100%", height: 600}}
                                        frameBorder="0"
                                        onLoad={() => { this.setState({ isLoading: false }) }}
                                        title={data.report_name}
                                        allowFullScreen
                                    >
                                    </iframe>
                                </TabPane>
                            )
                        })
                    }
                </TabContent>
            </Sticky>
        );
    }
    componentDidMount() {
        this.getDashboard();
        try {
            const availableDashboards = dashboards[companyType][userType] || dashboards[companyType]['default'];
            const keys = Object.keys(availableDashboards)
            this.handleOnClickForReport(availableDashboards[keys[0]][0])
        } catch (error) {
            
        }
    }
}

const mapStateToProps = ({common}) => {
  return {
    data: common.googleStudioReport || {}
  }
};


export default connect(mapStateToProps)(HolisticsDashboards);
